<div class="stepper-container">
    <div class="status-container" *ngFor="let status of getStatusList(); let i = index">
        <span
            class="status-circle"
            [ngClass]="{
                active: statusIsComplete(status?.id),
                'status-circle-dark': themeSwitcherService.isDarkModeEnabled$ | async,
                'status-circle-light': !(themeSwitcherService.isDarkModeEnabled$ | async),
            }"
        ></span>
        <p class="status-description">{{ status?.name }}</p>
        <hr *ngIf="canRenderStatusLine(i)" class="emd-divider status-line" />
    </div>
</div>
